import MainService from "@/services/MainService.js";

export default {
    name: "PersonaViaticoIndPage",

    data() {
        let ss = new MainService();
        return {
            ss: ss,
            auth: {},

            /* =========================
             * INPUTS
             * ========================= */
            persona: null,
            reparticionOrigen: null,
            reparticionDestino: null,

            searchPersona: "",
            searchReparticionOrigen: "",
            searchReparticionDestino: "",

            personas: [],
            reparticionesOrigen: [],
            reparticionesDestino: [],

            /* =========================
             * RESULTADOS (READ ONLY)
             * ========================= */
            resultado: {
                pasaje: 0,
                viatico: 0,
                flete: 0,
                total: 0,
                mensaje: ""
            },

            isLoading: false,
            errorBag: {}
        };
    },

    methods: {
        /* =========================
         * PERSONA
         * ========================= */
        searchPersonaMethod(q) {
            if (!q) {
                this.personas = [];
                return;
            }

            this.ss.select22Persona(q).then(res => {
                if (res.data.success) {
                    this.personas = res.data.items;
                } else {
                    this.personas = [];
                }
            });
        },

        onSelectPersona(item) {
            this.persona = item.CodigoPersona;
        },

        /* =========================
         * REPARTICIÓN ORIGEN
         * ========================= */
        searchReparticionOrigenMethod(q) {
            if (!q) {
                this.reparticionesOrigen = [];
                return;
            }

            this.ss.select2Reparticion(q).then(res => {
                if (res.data.success) {
                    this.reparticionesOrigen = res.data.items;
                } else {
                    this.reparticionesOrigen = [];
                }
            });
        },

        onSelectReparticionOrigen(item) {
            this.reparticionOrigen = item.id;
        },

        /* =========================
         * REPARTICIÓN DESTINO
         * ========================= */
        searchReparticionDestinoMethod(q) {
            if (!q) {
                this.reparticionesDestino = [];
                return;
            }

            this.ss.select2Reparticion(q).then(res => {
                if (res.data.success) {
                    this.reparticionesDestino = res.data.items;
                } else {
                    this.reparticionesDestino = [];
                }
            });
        },

        onSelectReparticionDestino(item) {
            this.reparticionDestino = item.id;
        },

        /* =========================
         * CALCULAR VIÁTICO (CORE)
         * ========================= */
        calcularViatico() {
            this.errorBag = {};
            this.isLoading = true;

            if (!this.persona || !this.reparticionOrigen || !this.reparticionDestino) {
                this.isLoading = false;
                this.$bvToast.toast(
                    "Debe seleccionar Persona, Repartición Origen y Destino",
                    { title: "Advertencia", variant: "warning" }
                );
                return;
            }

            const payload = {
                persona: this.persona,
                reparticion_origen: this.reparticionOrigen,
                reparticion_destino: this.reparticionDestino
            };

            this.ss.generarViaticoGral(payload)
                .then(res => {
                    const data = res.data;

                    this.resultado.pasaje = data.montopasajetotal || 0;
                    this.resultado.viatico = data.montoviaticototal || 0;
                    this.resultado.flete = data.montofletealmacenamientototal || 0;
                    this.resultado.total = data.montofinalviatico || 0;
                    this.resultado.mensaje = data.mensaje || "";

                    this.isLoading = false;
                })
                .catch(error => {
                    console.error(error);
                    this.isLoading = false;
                    this.$bvToast.toast(
                        "Error al calcular viático",
                        { title: "Error", variant: "danger" }
                    );
                });
        },

        /* =========================
         * LIMPIAR SIMULACIÓN
         * ========================= */
        limpiar() {
            this.persona = null;
            this.reparticionOrigen = null;
            this.reparticionDestino = null;
            this.searchPersona = "";
            this.searchReparticionOrigen = "";
            this.searchReparticionDestino = "";

            this.resultado = {
                pasaje: 0,
                viatico: 0,
                flete: 0,
                total: 0,
                mensaje: ""
            };
        }
    },

    mounted() {
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!this.auth) {
            this.$router.push("/Login");
        }
    }
};
